import React from 'react';
import { Container } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

const ServiceDetails = () => {
    const {serviceId} = useParams();
    return (
        <div className='serviceDetails py-5'>
            <Container style={{minHeight:'70vh'}} className='text-center'>
                <h2 className='py-5'>Welcome to detail: {serviceId}</h2>
                <Link to="/checkOut">
                    <button className='btn btn-primary'>Proceed Checkout</button>
                </Link>
            </Container>
        </div>
    );
};

export default ServiceDetails;